import { render, staticRenderFns } from "./HomeDiscover.vue?vue&type=template&id=3ce582f2&scoped=true&"
import script from "./HomeDiscover.vue?vue&type=script&lang=js&"
export * from "./HomeDiscover.vue?vue&type=script&lang=js&"
import style0 from "./HomeDiscover.vue?vue&type=style&index=0&id=3ce582f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce582f2",
  null
  
)

export default component.exports